import MeasurerGraphDialog from "./measurer-graph-dialog";
export default MeasurerGraphDialog;
